<template id="sectionBanner">
  <div :class="(this.bannerclass == null || this.bannerclass == '')?'innerBannertext':this.bannerclass">
    <div class="container" v-if="this.sname != null && this.sname != ''">
      <h1>{{this.sname}}</h1>
    </div>
  </div>
</template>

<script>

export default {
  name: 'sectionBanner',
  props:['name', 'sname', 'bannerclass'],
  data () {
    return {
    }
  },
  mounted: function() {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SectionBanner.vue